import { prepareHttpHeaders } from "./http";
import loginService from "./login-service";
import { setEnv } from "./env";

export const getMessages = async ({
  appConfiguration: { baseUrl, apiToken, bundleIdentifier },
  authorization
}) => {
  setEnv({
    BASE_URL: baseUrl,
    API_TOKEN: apiToken,
    BUNDLE_ID: bundleIdentifier
  });
  let memberId;
  try {
    memberId = await loginService(authorization);
  } catch (err) {
    throw new Error(err);
  }
  if (memberId) {
    return fetch(`${baseUrl}screens/message_center`, {
      method: "POST",
      headers: new Headers(prepareHttpHeaders()),
      body: JSON.stringify({ logged_in_member_id: memberId })
    }).then(async res => {
      const response = await res.json();
      if (response.error_code === 2) {
        setEnv({ AUTH_TOKEN: "" });
        return Promise.reject(new Error("WEBSDK_AUTH_ERROR"));
      }
      return response;
    });
  }
};
